import styled from "styled-components";

export const StyledTitle = styled.h1<{
	spotColor: number;
	hidden?: boolean;
	isHome?: boolean;
}>`
	font-size: 30px;
	font-family: "Salsa", cursive;
	cursor: pointer;

	width: fit-content;
	padding: 5px 20px;
	color: var(--orange);
	text-shadow: var(--textShadowBlack);
	transition: 0.5s;

	display: flex;
	justify-content: center;
	align-items: center;
	gap: 10px;

	&:hover {
		-webkit-filter: drop-shadow(5px 5px 5px #222);
		filter: drop-shadow(5px 5px 5px #222);
	}

	.img_btn_holder {
		position: relative;
		button {
			display: ${(props) => (props.isHome ? "none" : "block")};
			background-color: transparent;
			border: none;
			font-size: 30px;
			position: absolute;
			bottom: 10px;
			left: -20px;
			color: var(--orange);
			-webkit-filter: drop-shadow(2px 2px 2px #222);
			filter: drop-shadow(2px 2px 2px #222);
		}
	}

	div {
		display: flex;

		p {
			transition: 0.2s;
			&:hover {
				color: var(--blue50);
			}
		}
		p:nth-child(${(props) => props.spotColor + 1}) {
			color: var(--blue50);
		}
	}

	img {
		width: 80px;
		height: auto;
		-webkit-animation: shake-vertical 4s cubic-bezier(0.455, 0.03, 0.515, 0.955)
			infinite both;
		animation: shake-vertical 2s cubic-bezier(0.455, 0.03, 0.515, 0.955)
			infinite both;
	}

	@media (max-width: 600px) {
		& {
			font-size: 35px;
			width: 100%;
			justify-content: center;
			display: ${(props) => (props.hidden ? "none" : "flex")};
		}
	}

	@-webkit-keyframes shake-vertical {
		0%,
		100% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		10%,
		30%,
		50%,
		70% {
			-webkit-transform: translateY(-8px);
			transform: translateY(-8px);
		}
		20%,
		40%,
		60% {
			-webkit-transform: translateY(8px);
			transform: translateY(8px);
		}
		80% {
			-webkit-transform: translateY(6.4px);
			transform: translateY(6.4px);
		}
		90% {
			-webkit-transform: translateY(-6.4px);
			transform: translateY(-6.4px);
		}
	}
	@keyframes shake-vertical {
		0%,
		100% {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
		10%,
		30%,
		50%,
		70% {
			-webkit-transform: translateY(-8px);
			transform: translateY(-8px);
		}
		20%,
		40%,
		60% {
			-webkit-transform: translateY(8px);
			transform: translateY(8px);
		}
		80% {
			-webkit-transform: translateY(6.4px);
			transform: translateY(6.4px);
		}
		90% {
			-webkit-transform: translateY(-6.4px);
			transform: translateY(-6.4px);
		}
	}
`;
